export const DEV = location.hostname === "localhost"
